import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Styles
import "./assets/scss/app.scss";

const root = ReactDOM.createRoot(
  document.getElementById("sample-application") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
